export const SORTING_FEATURE_KEY = 'sorting';
